/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
let wasShownAdditionalQuestions = false;
let wasAnsweredAdditionalQuestions = false;

export const markAdditionalQuestionsShown = () => {
  wasShownAdditionalQuestions = true;
};

export const resetAdditionalQuestionsShownFlag = () => {
  wasShownAdditionalQuestions = false;
};

export const getAndResetAdditionalQuestionsFlag = () => {
  const value = wasShownAdditionalQuestions;
  resetAdditionalQuestionsShownFlag();
  return value;
};

export const markAdditionalQuestionsAnswered = () => {
  wasAnsweredAdditionalQuestions = true;
};

export const resetAdditionalQuestionsAnsweredFlag = () => {
  wasAnsweredAdditionalQuestions = false;
};

export const getAndResetAdditionalQuestionsAnsweredFlag = () => {
  const value = wasAnsweredAdditionalQuestions;
  resetAdditionalQuestionsAnsweredFlag();
  return value;
};
